/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Data_SectionInputs */

const fr_settings_data_section = /** @type {(inputs: Settings_Data_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données`)
};

const en_settings_data_section = /** @type {(inputs: Settings_Data_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Settings_Data_SectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_data_section = /** @type {((inputs?: Settings_Data_SectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Data_SectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_data_section(inputs)
	return en_settings_data_section(inputs)
});